import React from 'react';
import classnames from 'classnames';

import image1 from '../images/AwsDemo-2014.png';
import image2 from '../images/AwsDemo-2015.png';
import backgroundImage from '../images/AwsDemo-background.jpg';

import '../styles/AwsDemo.css';

class AwsDemo extends React.Component {

  render() {
    return (
      <div
        className={classnames('AwsDemo', this.props.className)}
        style={{
          backgroundImage: 'url(' + backgroundImage + ')'
        }}>
        <div className="AwsDemo-content">
          {
            [
              {
                image: image1,
                href: 'https://youtu.be/Wr6WirGn-6k?t=1h25m37s',
                title: 'AWS Summit 2014 - New York\nWorkDocs iPad App Demo',
                subtitle: '1:25:37~'
              },
              {
                image: image2,
                href: 'https://youtu.be/nWSd3IBycCI?t=1h7m50s',
                title: 'AWS Summit 2015 - Tokyo\nWorkDocs iPhone App Demo',
                subtitle: '1:07:50~'
              }
            ].map(({ image, href, title, subtitle }, idx) => (
              <a
                key={idx}
                className="AwsDemo-link"
                href={href}
                target="_blank"
                rel="noopener noreferrer">
                <div className="AwsDemo-imageWrapper">
                  <img
                    className="AwsDemo-image"
                    src={image}
                    alt="Aws Demo"
                  />
                </div>
                <div className="AwsDemo-title">
                  {title}
                </div>
                <div className="AwsDemo-subtitle">
                  {subtitle}
                </div>
              </a>
            ))
          }
        </div>
      </div>
    );
  }

}

export default AwsDemo;



// WEBPACK FOOTER //
// ./src/components/AwsDemo.js